// 메뉴 이미지들 임포트
// 식사류 이미지
import img1 from "../image/menu-meals/gorgonzola-pizza.png"; // 치즈피자
import img2 from "../image/menu-meals/pepperoni-pizza.png"; // 페퍼로니피자
import img3 from "../image/menu-meals/kimchi-fried-rice.png"; // 김치치즈볶음밥
import img4 from "../image/menu-meals/beef-bulgogi-bowl.png"; // 소불고기덮밥
import img7 from "../image/menu-meals/pork-cutlet.png"; // 돈까스

// 간식류 이미지
import snackImg1 from "../image/menu-snacks/chicken-karaage.png"; // 치킨가라아게
import snackImg2 from "../image/menu-snacks/wing-platter.png"; // 윙봉플래터
import snackImg3 from "../image/menu-snacks/rice-cake-sausage.png"; // 소떡소떡
import snackImg4 from "../image/menu-snacks/takoyaki.png"; // 타코야끼
import snackImg6 from "../image/menu-snacks/plain-croffle.png"; // 플레인크로플

// 음료 이미지
import americano from "../image/menu-drinks/americano.png";
import cafeLatte from "../image/menu-drinks/cafe-latte.png";
import vanillaLatte from "../image/menu-drinks/vanilla-latte.png";
import icedTea from "../image/menu-drinks/iced-tea.png";
import chamomile from "../image/menu-drinks/chamomile.png";
import ade from "../image/menu-drinks/ade.png";
import yogurtSmoothie from "../image/menu-drinks/yogurt-smoothie.png";

// 간식 추가 이미지
import frenchFries from "../image/menu-snacks/french-fries.png";
import yangnyeomChicken from "../image/menu-snacks/yangnyeom-chicken.png";

export const menuItems = [
  // 식사류 (5개)
  { image: img1, title: "치즈피자", name: "치즈피자", category: "meals", description: "쭉쭉 늘어나는 모짜렐라 치즈 피자" },
  { image: img2, title: "페퍼로니피자", name: "페퍼로니피자", category: "meals", description: "짭조름한 페퍼로니 토핑 가득" },
  { image: img3, title: "김치치즈볶음밥", name: "김치치즈볶음밥", category: "meals", description: "매콤한 김치와 고소한 치즈의 환상 조합" },
  { image: img4, title: "소불고기덮밥", name: "소불고기덮밥", category: "meals", description: "달달한 불고기 한그릇 든든하게" },
  { image: img7, title: "돈가스세트", name: "돈가스세트", category: "meals", description: "바삭한 돈가스 + 복숭아아이스티" },
  
  // 간식류 (6개)
  { image: snackImg1, title: "치킨가라아게", name: "치킨가라아게", category: "snacks", description: "고급 바삭촉촉 일본식 순살 치킨" },
  { image: snackImg2, title: "윙봉플래터", name: "윙봉플래터", category: "snacks", description: "윙과 봉! 푸짐한 닭날개 플래터" },
  { image: snackImg3, title: "소떡소떡", name: "소떡소떡", category: "snacks", description: "탱글소시지+쫄깃떡 찰떡궁합" },
  { image: snackImg4, title: "타코야끼", name: "타코야끼", category: "snacks", description: "겉바속촉! 인기 많은 일본간식" },
  { image: frenchFries, title: "모둠감자튀김", name: "모둠감자튀김", category: "snacks", description: "스틱, 웨지 골라먹는 감자파티" },
  { image: yangnyeomChicken, title: "양념치킨", name: "양념치킨", category: "snacks", description: "달콤매콤 양념 입은 순살치킨" },
  { image: snackImg6, title: "플레인크로플", name: "플레인크로플", category: "snacks", description: "겉바속촉! 기본에 충실한 크로플" },
  
  // 음료 (7개)
  { image: americano, title: "아메리카노", name: "아메리카노", category: "drinks", description: "진하게 내린 기본 커피" },
  { image: cafeLatte, title: "카페라떼", name: "카페라떼", category: "drinks", description: "부드러운 우유와 커피의 조화" },
  { image: vanillaLatte, title: "바닐라라떼", name: "바닐라라떼", category: "drinks", description: "달콤한 바닐라향 라떼" },
  { image: icedTea, title: "아이스티", name: "아이스티", category: "drinks", description: "상큼한 복숭아맛 시원한 티" },
  { image: chamomile, title: "캐모마일", name: "캐모마일", category: "drinks", description: "은은한 꽃향 가득 허브티" },
  { image: ade, title: "에이드", name: "에이드", category: "drinks", description: "톡 쏘는 과일향 탄산음료" },
  { image: yogurtSmoothie, title: "플레인요거트스무디", name: "플레인요거트스무디", category: "drinks", description: "상큼하고 부드러운 요거트스무디" },
];

export const noticeData = [
  { title: '[이벤트] 룰렛을 돌려 경품을 받아가세요.', date: '2025.08.08' },
  { title: '[공지] 민생회복 소비쿠폰 사용안내', date: '2025.08.08' },
  { title: '[공지] 8월 휴일안내', date: '2025.08.08' },
  { title: '[공지] 7월 휴일안내', date: '2025.07.07' },
  { title: '[체험행사] 7월 여름방학 체험행사 안내', date: '2025.07.07' },
];

export const contactButtons = [
  { type: 'individual', label: '개인 예약' },
  { type: 'group', label: '단체 예약' },
  { type: 'content', label: '콘텐츠 문의' },
  { type: 'business', label: '창업 문의' }
];